import React from 'react'
import AgentAvatar from './AgentAvatar'
import AgentName from './AgentName'
import ListIcon from '@material-ui/icons/FormatListBulleted'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  normalHeader: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '50px auto 48px',
    gridTemplateRows: '50px',
    gridGap: 20,
    alignItems: 'center',
    padding: '15px 20px 15px 15px',
    fontSize: '20px'
  },
  fullScreenHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '50px 10px auto 48px 48px',
    gridTemplateRows: '50px',
    alignItems: 'center',
    padding: '15px 10px 15px 15px',
    fontSize: '20px'
  },
  smallHeader: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    gridTemplateRows: '30px',
    display: 'grid',
    gridTemplateColumns: '35px auto 48px',
    gridGap: 15,
    alignItems: 'center',
    padding: '12px 20px 13px 15px',
    fontSize: '16px'
  },
  icon: {
    fill: theme.palette.primary.contrastText
  },
  badge: {
    color: 'white',
    backgroundColor: 'red'
  }
}))

function HistoryButton (props) {
  const classes = useStyles()

  if (props.bigPrompt) {
    return <></>
  }

  return (
    <IconButton onClick={props.toggle}>
      <ListIcon className={classes.icon} />
    </IconButton>
  )
}

function FullScreenHeader (props) {
  const classes = useStyles()

  const CloseButton = (
    <IconButton
      onClick={() => props.closeChat()} className={classes.button} classes={{ root: classes.buttonRoot }}>
      <CloseIcon className={classes.icon} />
    </IconButton>
  )

  return (
    <div className={classes.fullScreenHeader} style={{ borderRadius: 0, backgroundColor: props.contentHeader && !props.mode.startsWith('modal') ? 'white' : null, borderBottom: props.contentHeader ? '1px solid #ccc' : null }}>
      {!props.mode.startsWith('modal') && (
        <>
          <AgentAvatar avatarUrl={props.avatarUrl} size={50} />
          <div />
          <AgentName conversationLabel={props.conversationLabel} color={props.contentHeader ? '#4c4c4c' : null} />
          {!props.contentHeader &&
            <>
              <HistoryButton toggle={props.showConversationHistory} bigPrompt={false} />
              {CloseButton}
            </>
          }
        </>
      )}
      {props.mode.startsWith('modal') &&
        <>
          <div />
          <div />
          <div />
          <div />
          {CloseButton}
        </>
      }
    </div>
  )
}

function ChatHeader (props) {
  const classes = useStyles()

  let size = 50
  let headerClass = classes.normalHeader
  if (props.bigPrompt) {
    size = 35
    headerClass = classes.smallHeader
  } else if (props.fullScreen) {
    return (
      <FullScreenHeader
        mode={props.mode}
        closeChat={props.closeChat}
        avatarUrl={props.avatarUrl}
        conversationLabel={props.conversationLabel}
        showConversationHistory={props.showConversationHistory}
        contentHeader={props.contentHeader}
      />
    )
  }

  return (
    <div className={headerClass} style={{ borderRadius: props.fullScreen ? 0 : null }}>
      <AgentAvatar avatarUrl={props.avatarUrl} size={size} />
      <AgentName conversationLabel={props.conversationLabel} />
      <HistoryButton toggle={props.showConversationHistory} bigPrompt={props.bigPrompt} />
    </div>
  )
}

export default ChatHeader
